import convertArticlesFromApi from '@/helpers/convertArticlesFromApi.ts';

const getArticles = (api, params = {}) =>
  api
    .get('blogs/get', { params })
    .then(({ data }) =>
      data && Array.isArray(data.data)
        ? data.data.map(convertArticlesFromApi)
        : [],
    )
    .catch(() => commit('setArticles', []));

const getArticlesAction = ({ commit }, api) =>
  getArticles(api).then((result) => commit('setArticles', result));

const getEventsAction = (commit, prms, api) => {
  const { id, url } = prms;
  const params = { ...prms };
  if (id) params.event_id = id;
  delete params.url;
  delete params.id;
  return api
    .get(url, { params })
    .then(({ data }) => {
      const result =
        !data || !Array.isArray(data.data)
          ? []
          : data.data.map((items) => {
              const { age_from, age_to } = items;
              if (age_from === null || age_to === null)
                return { ...items, age_group_text: '' };
              return {
                ...items,
                age_group_text: `${parseFloat(age_from)} - ${parseFloat(
                  age_to,
                )} лет`,
              };
            });
      commit('setEvents', result);
    })
    .catch(() => commit('setEvents', []));
};

export { getArticles, getArticlesAction, getEventsAction };



// WEBPACK FOOTER //
// ./src/store/common/actions.js